import { z } from 'zod';
export const NARRATIVE_COMMUNITY_LIST_PAGE_SIZE = 9;
export const NARRATIVE_COMMUNITY_AFTER_QUERY_PARAM = 'after';
export const NARRATIVE_COMMUNITY_BEFORE_QUERY_PARAM = 'before';
/**
 * It will eagerly load more data by PRELOAD_OFFSET pixels before reaching the end of the page.
 * This will mean that people might not even notice that the page is loading more data unless scrolling aggressively.
 */
export const NARRATIVE_COMMUNITY_PRELOAD_OFFSET = 500;

const NarrativeListCursorSchema = z
  .string()
  .nullish()
  .transform((val) => val || undefined);

const NarrativeListPageParamsSchema = z.object({
  after: NarrativeListCursorSchema,
  before: NarrativeListCursorSchema,
});

export const narrativeListPageParamsSafeParse = (params: unknown) =>
  NarrativeListPageParamsSchema.safeParse(params).data ?? {
    after: undefined,
    before: undefined,
  };
